/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class AzureConnectionIdResponse {
  /**
  * The connection ID
  */
  'connectionId': string;
  /**
  * The location of the restore account resources
  */
  'location': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "connectionId",
      "baseName": "connectionId",
      "type": "string",
      "format": ""
    },
    {
      "name": "location",
      "baseName": "location",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureConnectionIdResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

